import { cellTypes } from "../CellTypeList";
import { changeCurrenCellType } from "./changeCurrentCellType";
import { State } from "./types";

export interface NumberPressedAction {
  number: number;
  type: "NUMBER PRESSED";
}

export const numberPressed = (
  state: State,
  action: NumberPressedAction,
): State => {
  let newSelectedCellTypeGroup = state.selectedCellTypeGroup;
  let newCellType = null;
  if (!state.selectedCellTypeGroup) {
    newSelectedCellTypeGroup = action.number === 1 ? 'Basic' : 'Summary'
  } else {
    newCellType = cellTypes[newSelectedCellTypeGroup as string][action.number - 1];
  }
  let newState = state;
  if (newCellType) {
    newState = changeCurrenCellType(state, {label:newCellType.label, type:"CHANGE CURRENT CELL TYPE"});
    newSelectedCellTypeGroup = null;
  }

  return {
    ...newState,
    selectedCellTypeGroup: newSelectedCellTypeGroup
  }
}

